module.exports = __webpack_public_path__ + "img/yb.fb70f09e.png";